var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"book",class:{
    active: _vm.book,
    animate: _vm.animate
  },attrs:{"target":"_blank","href":_vm.book.ExternalLink}},[_c('div',{staticClass:"top"}),_c('div',{staticClass:"inside"}),_c('div',{staticClass:"front"}),_c('div',{staticClass:"right"})])}
var staticRenderFns = []

export { render, staticRenderFns }